import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { FeatureCatalog } from "@/features/admin/components/feature-catalog";
import { PageContainer } from "@fleet/ui";

function AdminFeaturesPage() {
  return (
    <PageContainer maxWidth="4xl">
      <FeatureCatalog />
    </PageContainer>
  );
}

export const adminFeaturesRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/features",
  component: AdminFeaturesPage,
});
